/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class RestrictedAgeField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [{ key: 1, text: 'No', value: null }, { key: 2, text: 'Yes', value: 18 }]

    return (
      <Form.Select
        required
        fluid
        label="Restricted Age"
        options={options}
        placeholder="Is this store allow under 18 users to order?"
        onChange={(e, data) => onChange('restricted_age', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/restrictedAgeField.js